/* VECHEK Landing — Vanilla JS (Soporte Shopify AJAX API Robustecido) */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var root = document.querySelector('[data-vk-root]') || document.body;

    /* ---------------- NAV SCROLL STATE & MOBILE HAMBURGER MENU ---------------- */
    var nav = document.querySelector('[data-vk-nav]');
    var hamburgerBtn = document.querySelector('[data-vk-hamburger-toggle]');
    var navMenu = document.querySelector('[data-vk-nav-menu]');

    if (hamburgerBtn && navMenu) {
      hamburgerBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var isActive = hamburgerBtn.classList.toggle('is-active');
        navMenu.classList.toggle('is-active');
        hamburgerBtn.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      });

      // Close menu when clicking a link inside
      navMenu.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          hamburgerBtn.classList.remove('is-active');
          navMenu.classList.remove('is-active');
          hamburgerBtn.setAttribute('aria-expanded', 'false');
        });
      });

      // Close menu when clicking outside
      document.addEventListener('click', function (e) {
        if (nav && !nav.contains(e.target)) {
          hamburgerBtn.classList.remove('is-active');
          navMenu.classList.remove('is-active');
          hamburgerBtn.setAttribute('aria-expanded', 'false');
        }
      });
    }

    function onScroll() {
      if (!nav) return;
      var y = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
      if (y > 20) {
        nav.classList.add('is-scrolled');
      } else {
        nav.classList.remove('is-scrolled');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();

    /* ---------------- COLLECTION TABS & VER MÁS / VER MENOS ---------------- */
    var tabs = document.querySelectorAll('[data-vk-collection-tab]');
    var panels = document.querySelectorAll('[data-vk-collection-panel]');

    function initPanelLimits(panel) {
      if (!panel) return;
      var expandBtn = panel.querySelector('[data-vk-catalog-expand]');
      var cards = panel.querySelectorAll('[data-vk-card]');
      if (!cards.length) return;

      var limit = expandBtn ? parseInt(expandBtn.getAttribute('data-limit'), 10) || 12 : 12;
      var isExpanded = panel.getAttribute('data-expanded') === 'true';
      var visibleCount = 0;

      cards.forEach(function (card) {
        if (card.classList.contains('vk-filter-hidden')) {
          card.style.setProperty('display', 'none', 'important');
          return;
        }

        if (!isExpanded && visibleCount >= limit) {
          card.style.setProperty('display', 'none', 'important');
        } else {
          card.style.setProperty('display', '', '');
        }
        visibleCount++;
      });

      if (expandBtn) {
        if (visibleCount <= limit) {
          expandBtn.style.display = 'none';
        } else {
          expandBtn.style.display = '';
          expandBtn.textContent = isExpanded ? 'Ver menos' : 'Ver más';
        }
      }
    }

    panels.forEach(function (panel) { initPanelLimits(panel); });

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var targetHandle = tab.getAttribute('data-vk-collection-tab');

        tabs.forEach(function (t) { t.classList.remove('active'); });
        tab.classList.add('active');

        panels.forEach(function (panel) {
          if (panel.getAttribute('data-vk-collection-panel') === targetHandle) {
            panel.classList.remove('vk-tab-hidden');
            applyFiltersAndSort();
          } else {
            panel.classList.add('vk-tab-hidden');
          }
        });
      });
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-vk-catalog-expand]');
      if (!btn) return;

      var panel = btn.closest('[data-vk-collection-panel]');
      if (!panel) return;

      var currentlyExpanded = panel.getAttribute('data-expanded') === 'true';
      panel.setAttribute('data-expanded', currentlyExpanded ? 'false' : 'true');

      initPanelLimits(panel);

      if (currentlyExpanded) {
        var catalogSection = document.getElementById('catalogo');
        if (catalogSection) {
          catalogSection.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });

    /* ---------------- CATALOG FILTERS, SORT & SEARCH ---------------- */
    var sortToggle = document.querySelector('[data-vk-sort-toggle]');
    var sortMenu = document.querySelector('[data-vk-sort-menu]');
    var sortWrap = document.querySelector('[data-vk-sort-wrap]');

    if (sortToggle && sortMenu) {
      sortToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        sortMenu.classList.toggle('active');
      });

      document.addEventListener('click', function (e) {
        if (sortWrap && !sortWrap.contains(e.target)) {
          sortMenu.classList.remove('active');
        }
      });
    }

    function applyFiltersAndSort() {
      var activePanel = document.querySelector('[data-vk-collection-panel]:not(.vk-tab-hidden)');
      if (!activePanel) return;

      var grid = activePanel.querySelector('.vk-catalog-grid');
      if (!grid) return;

      var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-vk-card]'));

      var activeSortOpt = sortMenu ? sortMenu.querySelector('[data-vk-sort].active') : null;
      var sortType = activeSortOpt ? activeSortOpt.getAttribute('data-vk-sort') : 'default';

      var activePriceOpt = sortMenu ? sortMenu.querySelector('[data-vk-price-range].active') : null;
      var priceRange = activePriceOpt ? activePriceOpt.getAttribute('data-vk-price-range') : null;

      var stockOption = sortMenu ? sortMenu.querySelector('[data-vk-filter="in-stock"]') : null;
      var stockOnly = stockOption ? stockOption.classList.contains('active') : false;

      var searchInput = document.querySelector('[data-vk-catalog-search]');
      var searchTerm = searchInput ? searchInput.value.toLowerCase().trim() : '';

      cards.sort(function (a, b) {
        var priceA = parseFloat(a.getAttribute('data-price')) || 0;
        var priceB = parseFloat(b.getAttribute('data-price')) || 0;

        if (sortType === 'price-asc') return priceA - priceB;
        if (sortType === 'price-desc') return priceB - priceA;

        var indexA = parseInt(a.getAttribute('data-original-index'), 10) || 0;
        var indexB = parseInt(b.getAttribute('data-original-index'), 10) || 0;
        return indexA - indexB;
      });

      cards.forEach(function (card, index) {
        grid.appendChild(card);

        if (!card.hasAttribute('data-original-index')) {
          card.setAttribute('data-original-index', index);
        }

        var price = parseFloat(card.getAttribute('data-price')) || 0;
        var rawAvailable = (card.getAttribute('data-available') || '').toString().trim().toLowerCase();
        var isAvailable = rawAvailable === 'true';

        var titleEl = card.querySelector('.vk-card-name');
        var title = titleEl ? titleEl.textContent.toLowerCase() : '';

        var matchPrice = true;
        if (priceRange === 'under-1500') matchPrice = price < 1500;
        else if (priceRange === '1500-2500') matchPrice = price >= 1500 && price <= 2500;
        else if (priceRange === '2500-3500') matchPrice = price >= 2500 && price <= 3500;
        else if (priceRange === 'over-3500') matchPrice = price > 3500;

        var matchStock = !stockOnly || isAvailable;
        var matchSearch = !searchTerm || title.indexOf(searchTerm) !== -1;

        if (matchPrice && matchStock && matchSearch) {
          card.classList.remove('vk-filter-hidden');
        } else {
          card.classList.add('vk-filter-hidden');
        }
      });

      initPanelLimits(activePanel);
    }

    var sortOptions = document.querySelectorAll('[data-vk-sort]');
    sortOptions.forEach(function (option) {
      option.addEventListener('click', function () {
        var isActive = option.classList.contains('active');
        sortOptions.forEach(function (opt) { opt.classList.remove('active'); });
        if (!isActive) option.classList.add('active');

        applyFiltersAndSort();
      });
    });

    var priceOptions = document.querySelectorAll('[data-vk-price-range]');
    priceOptions.forEach(function (option) {
      option.addEventListener('click', function () {
        var isActive = option.classList.contains('active');
        priceOptions.forEach(function (opt) { opt.classList.remove('active'); });
        if (!isActive) option.classList.add('active');

        applyFiltersAndSort();
      });
    });

    var stockOption = document.querySelector('[data-vk-filter="in-stock"]');
    if (stockOption) {
      stockOption.addEventListener('click', function (e) {
        e.preventDefault();
        this.classList.toggle('active');
        applyFiltersAndSort();
      });
    }

    var searchInput = document.querySelector('[data-vk-catalog-search]');
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        applyFiltersAndSort();
      });
    }

    /* ---------------- SHOPIFY REAL AJAX CART ---------------- */
    function fmt(cents) {
      if (cents === undefined || cents === null || isNaN(cents)) cents = 0;
      var total = Number(cents) / 100;
      return '$' + total.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function openCartPanel() {
      var cartPanel = document.querySelector('[data-vk-cart-panel]');
      var cartBackdrop = document.querySelector('[data-vk-cart-backdrop]');
      if (cartPanel) cartPanel.classList.add('open');
      if (cartBackdrop) cartBackdrop.classList.add('open');
    }

    function closeCartPanel() {
      var cartPanel = document.querySelector('[data-vk-cart-panel]');
      var cartBackdrop = document.querySelector('[data-vk-cart-backdrop]');
      if (cartPanel) cartPanel.classList.remove('open');
      if (cartBackdrop) cartBackdrop.classList.remove('open');
    }

    function fetchAndRenderCart() {
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      
      // Evita problemas de caché agregando timestamp
      fetch(rootUrl + 'cart.js?t=' + Date.now(), {
        headers: { 'Cache-Control': 'no-cache' }
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) { renderCartPanel(cart); })
      .catch(function (err) { console.error('Error al obtener el carrito:', err); });
    }

    function renderCartPanel(cart) {
      if (!cart) return;

      var items = cart.items || [];
      var itemCount = 0;
      var calculatedTotal = 0;

      items.forEach(function (item) {
        var qty = item.quantity || 0;
        itemCount += qty;

        var linePrice = item.final_line_price !== undefined ? item.final_line_price : 
                       (item.line_price !== undefined ? item.line_price : ((item.price || 0) * qty));
        
        calculatedTotal += linePrice;
      });

      if (cart.total_price !== undefined && cart.total_price > 0) {
        calculatedTotal = cart.total_price;
      }

      // Badges y Contadores
      var dynamicBadge = document.querySelector('[data-vk-cart-badge]');
      if (dynamicBadge) {
        dynamicBadge.textContent = itemCount;
        if (itemCount > 0) dynamicBadge.classList.add('show');
        else dynamicBadge.classList.remove('show');
      }

      var dynamicCount = document.querySelector('[data-vk-cart-panel-count]');
      if (dynamicCount) {
        dynamicCount.textContent = itemCount + (itemCount === 1 ? ' artículo' : ' artículos');
      }

      // Actualizar total
      var formattedTotal = fmt(calculatedTotal);
      var totalElements = document.querySelectorAll('[data-vk-cart-total], .vk-cart-panel-total span:last-child');
      totalElements.forEach(function (el) {
        el.textContent = formattedTotal;
      });

      // Contenedores del panel
      var emptyEl = document.querySelector('[data-vk-cart-empty]');
      var footerEl = document.querySelector('[data-vk-cart-footer]');
      var listEl = document.querySelector('[data-vk-cart-items]');

      if (itemCount === 0 || items.length === 0) {
        if (emptyEl) emptyEl.style.display = 'block';
        if (listEl) listEl.innerHTML = '';
        if (footerEl) footerEl.style.display = 'none';
        return;
      }

      if (emptyEl) emptyEl.style.display = 'none';
      if (footerEl) footerEl.style.display = 'block';

      if (listEl) {
        var html = items.map(function (item) {
          var imgSrc = item.featured_image ? (item.featured_image.url || item.featured_image) : (item.image || '');
          var itemTitle = item.product_title || item.title || '';
          var linePrice = item.final_line_price !== undefined ? item.final_line_price : 
                         (item.line_price !== undefined ? item.line_price : ((item.price || 0) * item.quantity));

          return '' +
            '<div class="vk-cart-row">' +
              '<div class="vk-cart-row-img-wrap">' +
                (imgSrc ? '<img src="' + imgSrc + '" alt="' + itemTitle + '" class="vk-cart-row-img" />' : '') +
              '</div>' +
              '<div class="vk-cart-row-info">' +
                '<div class="vk-cart-row-name" title="' + itemTitle + '">' + itemTitle + '</div>' +
                '<div class="vk-cart-row-qty">' +
                  '<button type="button" data-cart-change-key="' + item.key + '" data-cart-qty="' + (item.quantity - 1) + '" aria-label="Reducir">–</button>' +
                  '<span>' + item.quantity + '</span>' +
                  '<button type="button" data-cart-change-key="' + item.key + '" data-cart-qty="' + (item.quantity + 1) + '" aria-label="Aumentar">+</button>' +
                '</div>' +
              '</div>' +
              '<div class="vk-cart-row-actions">' +
                '<div class="vk-cart-row-price">' + fmt(linePrice) + '</div>' +
                '<button type="button" class="vk-cart-row-remove" data-cart-change-key="' + item.key + '" data-cart-qty="0" title="Eliminar producto" aria-label="Eliminar producto">✕</button>' +
              '</div>' +
            '</div>';
        }).join('');

        listEl.innerHTML = html;
      }
    }

    function addToCartShopify(variantId, quantity, btnEl) {
      var vId = parseInt(variantId, 10);
      if (!vId || isNaN(vId)) {
        alert('Por favor selecciona una opción válida.');
        return;
      }

      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var originalText = btnEl ? btnEl.innerHTML : '';

      if (btnEl) {
        btnEl.disabled = true;
        btnEl.style.opacity = '0.7';
        btnEl.innerHTML = 'Agregando...';
      }

      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: vId, quantity: quantity }] })
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Error al agregar al carrito');
        return res.json();
      })
      .then(function () {
        fetchAndRenderCart();
        openCartPanel();
      })
      .catch(function (err) {
        console.error('Error:', err);
        alert('Ocurrió un problema al agregar el producto al carrito.');
      })
      .finally(function () {
        if (btnEl) {
          btnEl.disabled = false;
          btnEl.style.opacity = '1';
          btnEl.innerHTML = originalText;
        }
      });
    }

    function updateCartItemQty(lineKey, newQty) {
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(rootUrl + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: newQty })
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) { 
        if (cart && Array.isArray(cart.items)) {
          renderCartPanel(cart); 
        } else {
          fetchAndRenderCart();
        }
      })
      .catch(function (err) { 
        console.error('Error al actualizar cantidad:', err);
        fetchAndRenderCart();
      });
    }

    // Delegación GLOBAL de eventos
    document.addEventListener('click', function (e) {
      // Botón agregar al carrito
      var addBtn = e.target.closest('[data-vk-add-to-cart]');
      if (addBtn) {
        var variantId = addBtn.getAttribute('data-variant-id');
        var cardScope = addBtn.closest('[data-vk-qty-scope]');
        var qtyValEl = cardScope ? cardScope.querySelector('[data-vk-qty-val]') : null;
        var qty = qtyValEl ? (parseInt(qtyValEl.textContent, 10) || 1) : 1;
        addToCartShopify(variantId, qty, addBtn);
        return;
      }

      // Botón de cambio de cantidad / eliminación en fila del carrito
      var changeBtn = e.target.closest('[data-cart-change-key]');
      if (changeBtn) {
        var key = changeBtn.getAttribute('data-cart-change-key');
        var cartQty = parseInt(changeBtn.getAttribute('data-cart-qty'), 10);
        updateCartItemQty(key, cartQty);
        return;
      }

      // Abrir / Cerrar Carrito
      var cartToggleBtn = e.target.closest('[data-vk-cart-toggle]');
      if (cartToggleBtn) {
        var cartPanel = document.querySelector('[data-vk-cart-panel]');
        if (cartPanel && cartPanel.classList.contains('open')) closeCartPanel();
        else {
          fetchAndRenderCart();
          openCartPanel();
        }
        return;
      }

      // Backdrop del Carrito
      var backdropBtn = e.target.closest('[data-vk-cart-backdrop]');
      if (backdropBtn) {
        closeCartPanel();
        return;
      }
    });

    fetchAndRenderCart();

    /* ---------------- QTY STEPPERS ---------------- */
    document.addEventListener('click', function (e) {
      var incBtn = e.target.closest('[data-vk-qty-inc]');
      var decBtn = e.target.closest('[data-vk-qty-dec]');
      if (!incBtn && !decBtn) return;
      var scope = (incBtn || decBtn).closest('[data-vk-qty-scope]');
      if (!scope) return;
      var valEl = scope.querySelector('[data-vk-qty-val]');
      var val = parseInt(valEl.textContent, 10) || 1;
      if (incBtn) val += 1;
      if (decBtn) val = Math.max(1, val - 1);
      valEl.textContent = val;
    });

    /* ---------------- FAQ ACCORDION ---------------- */
    document.addEventListener('click', function (e) {
      var q = e.target.closest('[data-vk-faq-toggle]');
      if (!q) return;
      var item = q.closest('[data-vk-faq-item]');
      if (!item) return;
      item.classList.toggle('open');
    });

    /* ---------------- RECOMENDADOR DINÁMICO ---------------- */
    var rules = [];
    var dataEl = document.getElementById('vk-recommendations-data');
    if (dataEl) {
      try {
        rules = JSON.parse(dataEl.textContent);
      } catch (err) {
        console.error('Error leyendo JSON de recomendaciones:', err);
      }
    }

    var selectedSpecies = null;

    var step1 = document.querySelector('#vk-step-1-content');
    var step2 = document.querySelector('#vk-step-2-content');
    var step3 = document.querySelector('#vk-step-3-content');

    var s1Num = document.querySelector('#vk-reco-step1-num');
    var s1Txt = document.querySelector('#vk-reco-step1-txt');
    var s2Num = document.querySelector('#vk-reco-step2-num');
    var s2Txt = document.querySelector('#vk-reco-step2-txt');
    var s3Num = document.querySelector('#vk-reco-step3-num');
    var s3Txt = document.querySelector('#vk-reco-step3-txt');

    document.querySelectorAll('.vk-species-opt').forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectedSpecies = this.getAttribute('data-species');
        renderSymptoms(selectedSpecies);

        if (step1) step1.style.display = 'none';
        if (step2) step2.style.display = 'block';

        if (s2Num) {
          s2Num.style.background = 'rgb(10, 9, 0)';
          s2Num.style.color = 'rgb(255, 255, 255)';
        }
        if (s2Txt) s2Txt.style.color = 'rgb(10, 9, 0)';
      });
    });

    var backBtn1 = document.querySelector('#vk-reco-back-1');
    if (backBtn1) {
      backBtn1.addEventListener('click', function () {
        if (step2) step2.style.display = 'none';
        if (step1) step1.style.display = 'block';

        if (s2Num) {
          s2Num.style.background = 'rgb(238, 238, 238)';
          s2Num.style.color = 'rgb(201, 197, 189)';
        }
        if (s2Txt) s2Txt.style.color = 'rgb(201, 197, 189)';
      });
    }

    var resetBtn = document.querySelector('#vk-reco-reset');
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        if (step3) step3.style.display = 'none';
        if (step2) step2.style.display = 'none';
        if (step1) step1.style.display = 'block';

        [s2Num, s3Num].forEach(function (el) {
          if (el) {
            el.style.background = 'rgb(238, 238, 238)';
            el.style.color = 'rgb(201, 197, 189)';
          }
        });
        [s2Txt, s3Txt].forEach(function (el) {
          if (el) el.style.color = 'rgb(201, 197, 189)';
        });
      });
    }

    function renderSymptoms(species) {
      var symptomsList = document.querySelector('#vk-symptoms-list');
      if (!symptomsList) return;
      symptomsList.innerHTML = '';

      var matchingRules = rules.filter(function (r) { return r.species === species; });

      if (matchingRules.length === 0) {
        symptomsList.innerHTML = '<p style="color:#6b6560; font-size:14px; grid-column: 1 / -1;">No hay sospechas clínicas configuradas para esta especie.</p>';
        return;
      }

      var uniqueSymptoms = [];
      matchingRules.forEach(function (rule) {
        if (uniqueSymptoms.indexOf(rule.symptom) === -1) {
          uniqueSymptoms.push(rule.symptom);
        }
      });

      uniqueSymptoms.forEach(function (symptomText) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'scp3';
        btn.style.cssText = 'padding: 18px 20px; border-radius: 14px; border: 1.5px solid rgba(0, 0, 0, 0.08); background: rgb(250, 250, 250); cursor: pointer; text-align: left; font-family: Poppins, sans-serif; font-size: 15px; font-weight: 700; color: rgb(10, 9, 0);';
        btn.innerHTML = '<span class="sc-interp">' + symptomText + '</span>';

        btn.addEventListener('click', function () {
          var matchedProds = [];
          matchingRules
            .filter(function (r) { return r.symptom === symptomText; })
            .forEach(function (r) {
              if (Array.isArray(r.products)) {
                r.products.forEach(function (p) {
                  matchedProds.push(p);
                });
              }
            });

          renderProductRecommendation(matchedProds);

          if (step2) step2.style.display = 'none';
          if (step3) step3.style.display = 'block';

          if (s3Num) {
            s3Num.style.background = 'rgb(10, 9, 0)';
            s3Num.style.color = 'rgb(255, 255, 255)';
          }
          if (s3Txt) s3Txt.style.color = 'rgb(10, 9, 0)';
        });

        symptomsList.appendChild(btn);
      });
    }

    function renderProductRecommendation(products) {
      var container = document.querySelector('#vk-recommended-products');
      if (!container) return;
      container.innerHTML = '';

      if (!products || products.length === 0) {
        container.innerHTML = '<p style="color:#6b6560; font-size:14px;">No se encontraron productos recomendados para esta opción.</p>';
        return;
      }

      products.forEach(function (prod) {
        var card = document.createElement('div');
        card.setAttribute('data-dc-tpl', '430');
        card.setAttribute('data-vk-qty-scope', '');
        card.style.cssText = 'display: flex; align-items: center; gap: 16px; border: 1px solid rgba(255, 128, 0, 0.15); background: linear-gradient(160deg, rgb(255, 255, 255), rgb(255, 250, 240)); border-radius: 16px; padding: 18px 20px; flex-wrap: wrap;';
        
        var imageMarkup = prod.image 
          ? '<img src="' + prod.image + '" alt="' + prod.title + '" style="width:100%; height:100%; object-fit:cover;">' 
          : '<div style="display:flex;align-items:center;justify-content:center;height:100%;color:#a09080;font-size:11px;">Foto</div>';

        card.innerHTML = 
          '<div data-dc-tpl="431" style="width: 56px; height: 56px; border-radius: 12px; background: rgb(238, 241, 245); flex-shrink: 0; overflow: hidden;">' +
            imageMarkup +
          '</div>' +
          '<div data-dc-tpl="433" style="flex: 1 1 0%; min-width: 180px;">' +
            '<div data-dc-tpl="434" style="font-family: Poppins, sans-serif; font-size: 15px; font-weight: 700; color: rgb(10, 9, 0); margin-bottom: 4px;"><span class="sc-interp">' + prod.title + '</span></div>' +
            '<div data-dc-tpl="435" style="font-size: 13px; color: rgb(107, 101, 96);"><span class="sc-interp">10 minutos</span> · <span class="sc-interp">97.8%</span> especificidad · <span class="sc-interp">' + prod.price + '</span></div>' +
          '</div>' +
          '<div data-dc-tpl="436" style="display: flex; align-items: center; gap: 10px;">' +
            '<div data-dc-tpl="437" style="display: flex; align-items: center; justify-content: space-between; border: 1px solid rgba(0, 0, 0, 0.12); border-radius: 999px; padding: 6px 12px; background: rgb(255, 255, 255);">' +
              '<button type="button" data-vk-qty-dec style="width: 16px; height: 16px; border: none; background: none; font-size: 14px; font-weight: 700; color: rgb(55, 65, 79); cursor: pointer; line-height: 1; padding: 0px;">−</button>' +
              '<span data-vk-qty-val style="font-size: 13px; font-weight: 700; color: rgb(10, 9, 0); min-width: 18px; text-align: center;"><span class="sc-interp">1</span></span>' +
              '<button type="button" data-vk-qty-inc style="width: 16px; height: 16px; border: none; background: none; font-size: 14px; font-weight: 700; color: rgb(55, 65, 79); cursor: pointer; line-height: 1; padding: 0px;">+</button>' +
            '</div>' +
            '<button type="button" class="vk-add-btn" data-vk-add-to-cart data-variant-id="' + prod.id + '" style="display: flex; align-items: center; gap: 6px; font-size: 13px; font-weight: 700; padding: 10px 18px; border-radius: 999px; border: none; cursor: pointer; background: linear-gradient(135deg, rgb(233, 157, 84) 0%, rgb(255, 179, 71) 100%); color: rgb(255, 255, 255); font-family: Poppins, sans-serif; white-space: nowrap;">Agregar al carrito</button>' +
          '</div>';

        container.appendChild(card);
      });
    }

    /* ---------------- CONTROL DE VIDEO AUTOMÁTICO AL CLIC ---------------- */
    var videoContainer = document.querySelector('[data-vk-video-container]');

    if (videoContainer) {
      var poster = videoContainer.querySelector('[data-vk-video-poster]');
      var iframe = videoContainer.querySelector('[data-vk-video-iframe]');
      var nativeVideo = videoContainer.querySelector('[data-vk-video-element]');

      if (poster) {
        poster.addEventListener('click', function () {
          // 1. Ocultar portada con animación suave
          poster.classList.add('is-hidden');

          // 2. Si es un video subido nativamente a Shopify (.mp4 / HTML5 Video)
          if (nativeVideo) {
            nativeVideo.play();
          } 
          // 3. Si es iframe (YouTube / Vimeo)
          else if (iframe) {
            var rawSrc = iframe.getAttribute('data-src');
            if (rawSrc) {
              var separator = rawSrc.indexOf('?') !== -1 ? '&' : '?';
              iframe.src = rawSrc + separator + 'autoplay=1';
            }
          }
        });
      }
    }
  });
})();